<template>
    <div class="dm-dashboard" v-loading.fullscreen.lock="loadingStats">
        <div class="dashboard-header">
            <h1>Dashboard - Dispositivos Médicos</h1>
            <!-- <p>Panel de control para gestión de dispositivos médicos</p> -->
        </div>

        <div class="dashboard-content" v-if="stats && stats.registros">
            <!-- Loading overlay para las estadísticas -->
            <div v-if="loadingStats" class="loading-overlay">
                <div class="loading-content">
                    <i class="el-icon-loading"></i>
                    <p>Cargando estadísticas...</p>
                </div>
            </div>

            <div class="stats-grid" :class="{ 'loading': loadingStats }">
                <div class="stat-card">
                    <div class="stat-icon">
                        <i class="el-icon-document-add"></i>
                    </div>
                    <div class="stat-info">
                        <h3>{{ stats.registros.total }}</h3>
                        <p>Total Remitos</p>
                    </div>
                </div>

                <div class="stat-card">
                    <div class="stat-icon">
                        <i class="el-icon-sell"></i>
                    </div>
                    <div class="stat-info">
                        <h3>{{ stats.registros_hoy.total }}</h3>
                        <p>Entregados Hoy</p>
                    </div>
                </div>

                <div class="stat-card">
                    <div class="stat-icon">
                        <i class="el-icon-message"></i>
                    </div>
                    <div class="stat-info">
                        <h3>{{ stats.registros.pendientes }}</h3>
                        <p>Pendientes de envío</p>
                    </div>
                </div>

                <div class="stat-card" @click="navigateToMedicos" style="cursor: pointer;">
                    <div class="stat-icon">
                        <i class="el-icon-user-solid"></i>
                    </div>
                    <div class="stat-info">
                        <h3>{{ stats.medicos.medicos }}</h3>
                        <p>Teléfonos Registrados</p>
                    </div>
                </div>
            </div>

            <div class="executions-section">
                <h2>Registro de actividad</h2>
                <div class="executions-container">
                    <div class="executions-chart">
                        <div slot="header"></div>
                        <el-table :data="stats.ejecuciones" style="width: 100%" height="500px" fit border stripe
                            size="mini">
                            <!-- <el-table-column prop="tarea" label="Tarea" width="300"></el-table-column> -->
                            <el-table-column prop="fecha" label="Fecha" width="150">
                                <template slot-scope="scope">
                                    <span>
                                        <span>{{ formatFechaUTC(scope.row.fecha) }}</span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="estado" label="Status" width="60">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.tarea !== 'Crear casos en Wise'"
                                        style="color: #000000; font-size: 16px;" class="el-icon-circle-plus">
                                    </span>
                                    <span class="el-icon-success" style="color: #008000; font-size: 16px;"
                                        v-if="scope.row.tarea === 'Crear casos en Wise' && parseInt(scope.row.duracion) > 0"></span>
                                    <span class="el-icon-warning" style="color: #ff0000; font-size: 16px;"
                                        v-if="!parseInt(scope.row.duracion)"></span>
                                    <span> {{ parseInt(scope.row.duracion) }}s</span>

                                </template>
                            </el-table-column>
                            <el-table-column prop="casos_creados" label="Resultado">
                                <template slot-scope="scope">
                                    <span
                                        v-if="scope.row.tarea === 'Crear casos en Wise' && scope.row.casos_creados > 0">
                                        Casos creados en Wise </span>
                                    <span
                                        v-if="scope.row.tarea === 'Crear casos en Wise' && scope.row.casos_creados == 0">
                                        Sin remitos pendientes</span>
                                    <span v-if="scope.row.tarea !== 'Crear casos en Wise'"> Total: {{
                                        scope.row.casos_creados }} | </span>
                                    <span v-if="scope.row.tarea !== 'Crear casos en Wise'"> mensajes:{{
                                        scope.row.casos_ws }} |</span>
                                    <span v-if="scope.row.tarea !== 'Crear casos en Wise'"> internos:{{
                                        scope.row.casos_internos }} |</span>
                                    <span v-if="scope.row.tarea !== 'Crear casos en Wise'"> multiples:{{
                                        scope.row.casos_multiple }} |</span>
                                    <span v-if="scope.row.tarea !== 'Crear casos en Wise'"> error:{{ scope.row.error
                                    }}</span>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <div class="executions-summary">
                        <div class="summary-card">
                            <div class="summary-header">
                                <div class="title-with-actions">
                                    <h4>Resumen</h4>
                                    <el-button type="text" size="mini" @click="copyTableToExcel"
                                        title="Copiar tabla para Excel" class="copy-excel-btn">
                                        <i class="el-icon-document-copy"></i>
                                    </el-button>
                                </div>
                                <div class="date-filter-inline">
                                    <el-date-picker v-model="fechaRango" type="daterange" range-separator="al"
                                        start-placeholder="Fecha inicio" end-placeholder="Fecha fin" format="dd/MM/yyyy"
                                        value-format="yyyyMMdd" :picker-options="pickerOptionsRango"
                                        @change="onDateRangeChange" size="mini" style="width: 280px;">
                                    </el-date-picker>
                                    <el-button v-if="fechaRango && fechaRango.length > 0" type="text" size="mini"
                                        @click="limpiarFiltro" style="margin-left: 8px; color: #999;">
                                        <i class="el-icon-close"></i>
                                    </el-button>
                                </div>
                            </div>
                            <el-table :data="summaryData" style="width: 100%" :border="false" stripe>
                                <el-table-column prop="label" label="Métrica"></el-table-column>
                                <el-table-column prop="hoy" label="Hoy" width="100" align="right">
                                    <template slot-scope="scope">
                                        <span class="value-today">{{ scope.row.hoy }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="total" label="Total" width="100" align="right">
                                    <template slot-scope="scope">
                                        <span class="value-total">{{ scope.row.total }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>



                        <div class="summary-card">
                            <h4>Estado del Sistema</h4>
                            <div class="status-item">
                                <span class="status-dot active"></span>
                                <span class="status-text">Sistema Activo</span>
                            </div>
                            <div class="status-item">
                                <span class="status-dot" :class="stats.ultimaEjecucion ? 'active' : 'inactive'"></span>
                                <span class="status-text">Última ejecución: {{
                                    formatFechaUTC(stats.ejecuciones[0].fecha) || 'N/A' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HTTP, DM } from "@/axios.js";
export default {
    name: 'DispositivosMedicosDashboard',
    data() {
        return {
            loadingStats: true,
            stats: {

            },
            fechaRango: [],
            pickerOptionsRango: {
                disabledDate(time) {
                    // Deshabilitar fechas anteriores a agosto 2025
                    const minDate = new Date('2025-08-01');
                    return time.getTime() < minDate.getTime();
                }
            }
        }
    },
    computed: {
        maxEjecuciones() {
            return Math.max(...this.hourlyData.map(hour => hour.ejecuciones));
        },
        maxCasos() {
            return Math.max(...this.hourlyData.map(hour => hour.casos));
        },
        promedioPorHora() {
            const totalEjecuciones = this.hourlyData.reduce((sum, hour) => sum + hour.ejecuciones, 0);
            return Math.round(totalEjecuciones / this.hourlyData.length);
        },
        horaMasActiva() {
            const maxEjecuciones = Math.max(...this.hourlyData.map(hour => hour.ejecuciones));
            const horaMasActiva = this.hourlyData.find(hour => hour.ejecuciones === maxEjecuciones);
            return horaMasActiva ? `${horaMasActiva.hora}:00` : 'N/A';
        },
        maxEjecucionesHora() {
            return Math.max(...this.hourlyData.map(hour => hour.ejecuciones));
        },
        maxCasosHora() {
            return Math.max(...this.hourlyData.map(hour => hour.casos));
        },
        totalMensajes() {
            // Calcular total de mensajes desde las ejecuciones
            return this.stats.ejecuciones ?
                this.stats.ejecuciones.reduce((total, ejecucion) => total + (ejecucion.casos_ws || 0), 0) : 0;
        },
        totalInternos() {
            // Calcular total de internos desde las ejecuciones
            return this.stats.ejecuciones ?
                this.stats.ejecuciones.reduce((total, ejecucion) => total + (ejecucion.casos_internos || 0), 0) : 0;
        },
        totalMultiples() {
            // Calcular total de múltiples desde las ejecuciones
            return this.stats.ejecuciones ?
                this.stats.ejecuciones.reduce((total, ejecucion) => total + (ejecucion.casos_multiple || 0), 0) : 0;
        },
        summaryData() {
            return [
                {
                    label: 'Casos Creados',
                    hoy: this.stats.registros_hoy.total || 0,
                    total: this.stats.registros?.total || 0
                },
                {
                    label: 'Mensajes enviados',
                    hoy: this.stats.registros_hoy.mensajes_enviados || 0,
                    total: this.stats.registros?.mensajes_enviados
                },
                {
                    label: 'Internos',
                    hoy: this.stats.registros_hoy.mensajes_internos || 0,
                    total: this.stats.registros?.mensajes_internos
                },
                {
                    label: 'Multiples',
                    hoy: this.stats.registros_hoy.mensajes_multiples || 0,
                    total: this.stats.registros?.mensajes_multiples
                }
            ];
        }
    },
    methods: {
        navigateTo(routeName) {
            this.$router.push({ name: routeName });
        },
        navigateToMedicos() {
            this.$router.push('/dm/medicos');
        },
        formatFechaUTC(fecha) {
            if (!fecha) return "";
            return this.$moment.utc(fecha) // lee como UTC
                .utcOffset(-3)                        // ajusta a UTC-3
                .format("DD/MM/YYYY HH:mm");          // muestra en formato
        },
        loadStats() {
            this.loadingStats = true;
            let url = DM + "/getStats";
            let datos = {
                desde: this.fechaRango && this.fechaRango.length === 2 ? this.fechaRango[0] : null,
                hasta: this.fechaRango && this.fechaRango.length === 2 ? this.fechaRango[1] : null,
            };
            // Si hay fechas seleccionadas, agregar parámetros de consulta
            const params = [];
            // if (this.fechaRango && this.fechaRango.length === 2) {
            //     params.push(`desde=${this.fechaRango[0]}`);
            //     params.push(`hasta=${this.fechaRango[1]}`);
            // }

            // if (params.length > 0) {
            //     url += `?${params.join('&')}`;
            // }

            HTTP.post(url, datos).then((res) => {
                this.stats = res.data;
                this.loadingStats = false;
            }).catch((error) => {
                console.error('Error cargando estadísticas:', error);
                this.$message.error('Error al cargar las estadísticas');
            }).finally(() => {
                this.loadingStats = false;
            });
        },
        onDateRangeChange(dateRange) {
            // Método llamado cuando cambia el rango de fechas
            console.log('Rango de fechas cambiado:', dateRange);
            if (dateRange && dateRange.length === 2) {
                this.loadStats();
                this.$message.success('Filtro aplicado correctamente');
            }
        },
        limpiarFiltro() {
            this.fechaRango = [];
            this.loadStats();
            this.$message.info('Filtro de fechas limpiado');
        },
        copyTableToExcel() {
            try {
                // Crear el contenido de la tabla en formato compatible con Excel
                let excelContent = 'Métrica\tHoy\tTotal\n';

                this.summaryData.forEach(row => {
                    excelContent += `${row.label}\t${row.hoy}\t${row.total}\n`;
                });

                // Copiar al portapapeles
                if (navigator.clipboard && window.isSecureContext) {
                    // Método moderno para HTTPS
                    navigator.clipboard.writeText(excelContent)
                        .then(() => {
                            this.$message.success('Datos copiados.');
                        })
                        .catch(() => {
                            this.fallbackCopyToClipboard(excelContent);
                        });
                } else {
                    // Método de respaldo para HTTP
                    this.fallbackCopyToClipboard(excelContent);
                }
            } catch (error) {
                console.error('Error al copiar:', error);
                this.$message.error('Error al copiar la tabla');
            }
        },
        fallbackCopyToClipboard(text) {
            // Método de respaldo para copiar al portapapeles
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                document.execCommand('copy');
                this.$message.success('Datos copiados.');
            } catch (err) {
                console.error('Error en fallback copy:', err);
                this.$message.error('Error al copiar');
            } finally {
                document.body.removeChild(textArea);
            }
        }
    },
    mounted() {
        this.loadStats();
    }
}
</script>

<style lang="scss" scoped>
.dm-dashboard {
    padding: 20px;
    min-height: 100vh;
    background-color: #f5f5f5;

    .dashboard-header {
        margin-bottom: 30px;
        text-align: center;

        h1 {
            color: #2C3E50;
            font-size: 2.5em;
            margin-bottom: 10px;
            font-weight: 600;
        }

        p {
            color: #3498DB;
            font-size: 1.1em;
            margin: 0;
        }
    }

    .dashboard-content {
        .stats-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 20px;
            margin-bottom: 40px;

            .stat-card {
                background: white;
                border-radius: 12px;
                padding: 25px;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                display: flex;
                align-items: center;
                transition: transform 0.3s ease, box-shadow 0.3s ease;

                &:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 8px 25px rgba(96, 125, 139, 0.2);
                }

                .stat-icon {
                    background: linear-gradient(135deg, #2C3E50, #3498DB);
                    color: white;
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 20px;

                    i {
                        font-size: 24px;
                    }
                }

                .stat-info {
                    h3 {
                        color: #2C3E50;
                        font-size: 2em;
                        margin: 0 0 5px 0;
                        font-weight: bold;
                    }

                    p {
                        color: #3498DB;
                        margin: 0;
                        font-size: 14px;
                    }
                }
            }
        }

        .executions-section {
            h2 {
                color: #2C3E50;
                font-size: 1.8em;
                margin-bottom: 20px;
                text-align: center;
            }

            .executions-container {
                display: grid;
                grid-template-columns: 1.5fr 1fr;
                gap: 30px;

                .executions-chart {
                    background: white;
                    border-radius: 12px;
                    padding: 25px;
                    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

                    .chart-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 20px;

                        h3 {
                            color: #2C3E50;
                            margin: 0;
                            font-size: 1.2em;
                        }

                        .chart-legend {
                            display: flex;
                            gap: 15px;

                            .legend-item {
                                display: flex;
                                align-items: center;
                                gap: 5px;
                                font-size: 12px;
                                color: #666;

                                .legend-color {
                                    width: 12px;
                                    height: 12px;
                                    border-radius: 2px;

                                    &.ejecuciones {
                                        background: #3498DB;
                                    }

                                    &.casos {
                                        background: #E74C3C;
                                    }
                                }
                            }
                        }
                    }

                    .chart-container {
                        .chart-bars {
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-end;
                            height: 150px;
                            padding: 20px 0;
                            overflow-x: auto;

                            .chart-hour {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                min-width: 35px;
                                margin: 0 1px;

                                .hour-label {
                                    font-size: 9px;
                                    color: #666;
                                    margin-bottom: 6px;
                                    font-weight: 500;
                                }

                                .bars-container {
                                    display: flex;
                                    gap: 1px;
                                    height: 80px;
                                    align-items: flex-end;
                                    width: 100%;

                                    .bar {
                                        flex: 1;
                                        min-height: 2px;
                                        border-radius: 1px;
                                        transition: all 0.3s ease;

                                        &.ejecuciones-bar {
                                            background: #3498DB;
                                        }

                                        &.casos-bar {
                                            background: #E74C3C;
                                        }

                                        &:hover {
                                            opacity: 0.8;
                                        }
                                    }
                                }

                                .hour-values {
                                    display: flex;
                                    flex-direction: column;
                                    gap: 1px;
                                    margin-top: 3px;

                                    .value {
                                        font-size: 7px;
                                        font-weight: 500;

                                        &.ejecuciones {
                                            color: #3498DB;
                                        }

                                        &.casos {
                                            color: #E74C3C;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                .executions-summary {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;

                    .summary-card {
                        background: white;
                        border-radius: 12px;
                        padding: 20px;
                        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

                        h4 {
                            color: #2C3E50;
                            margin: 0 0 15px 0;
                            font-size: 1.2em;
                            font-weight: 600;
                            border-bottom: 2px solid #3498DB;
                            padding-bottom: 8px;
                        }

                        .summary-header {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-bottom: 15px;
                            // border-bottom: 2px solid #3498DB;

                            .title-with-actions {
                                display: flex;
                                align-items: center;
                                gap: 8px;

                                h4 {
                                    margin: 0;
                                    border: none;
                                    padding: 0;
                                }

                                .copy-excel-btn {
                                    padding: 4px 6px;
                                    min-height: auto;
                                    color: #606266;
                                    transition: all 0.3s ease;

                                    &:hover {
                                        color: #3498DB;
                                        background-color: #f0f9ff;
                                        border-radius: 4px;
                                    }

                                    i {
                                        font-size: 14px;
                                    }
                                }
                            }

                            h4 {
                                margin: 0;
                                border: none;
                                padding: 0;
                            }

                            .date-filter-inline {
                                display: flex;
                                align-items: center;

                                .el-date-editor {
                                    .el-input__inner {
                                        border-radius: 6px;
                                        border: 1px solid #dcdfe6;
                                        font-size: 12px;
                                        transition: border-color 0.3s ease;

                                        &:hover {
                                            border-color: #3498DB;
                                        }

                                        &:focus {
                                            border-color: #3498DB;
                                            box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
                                        }
                                    }
                                }

                                .el-button--text {
                                    padding: 0;
                                    min-height: auto;

                                    &:hover {
                                        color: #E74C3C;
                                    }
                                }
                            }
                        }

                        .summary-item,
                        .status-item,
                        .peak-item {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-bottom: 10px;
                            background: #f8f9fa;
                            padding: 10px 12px;
                            border-radius: 6px;
                            transition: all 0.3s ease;

                            &:hover {
                                background: #e9ecef;
                                transform: translateX(3px);
                            }

                            &:last-child {
                                margin-bottom: 0;
                            }

                            .label,
                            .peak-label {
                                color: #2C3E50;
                                font-size: 14px;
                                font-weight: 500;
                            }

                            .value,
                            .peak-value {
                                color: #3498DB;
                                font-weight: 700;
                                font-size: 16px;
                            }
                        }

                        // Estilos para la tabla de resumen
                        .el-table {
                            border: none !important;

                            .value-today {
                                color: #27AE60;
                                font-weight: 700;
                                font-size: 14px;
                            }

                            .value-total {
                                color: #3498DB;
                                font-weight: 700;
                                font-size: 14px;
                            }

                            .el-table__header {
                                th {
                                    background-color: #f8f9fa;
                                    color: #2C3E50;
                                    font-weight: 600;
                                    text-align: center;
                                    border: none !important;
                                    border-bottom: 1px solid #e4e7ed !important;
                                }
                            }

                            .el-table__body {
                                tr {
                                    background-color: #ffffff;

                                    &:nth-child(even) {
                                        background-color: #fafbfc;
                                    }

                                    &:hover {
                                        background-color: #f0f2f5 !important;
                                    }
                                }

                                td {
                                    padding: 12px 8px;
                                    text-align: center;
                                    border: none !important;
                                }
                            }

                            // Quitar todos los bordes
                            &::before {
                                display: none;
                            }

                            .el-table__border-left-patch,
                            .el-table__border-right-patch {
                                display: none;
                            }
                        }

                        .status-dot {
                            width: 10px;
                            height: 10px;
                            border-radius: 50%;
                            margin-right: 8px;

                            &.active {
                                background: #27AE60;
                                box-shadow: 0 0 6px rgba(39, 174, 96, 0.3);
                            }

                            &.inactive {
                                background: #E74C3C;
                                box-shadow: 0 0 6px rgba(231, 76, 60, 0.3);
                            }
                        }

                        .status-text {
                            color: #2C3E50;
                            font-size: 14px;
                            font-weight: 500;
                        }


                    }
                }
            }
        }
    }

    // Loading styles
    .loading-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        border-radius: 12px;

        .loading-content {
            text-align: center;
            color: #3498DB;

            i {
                font-size: 32px;
                margin-bottom: 10px;
                animation: spin 1s linear infinite;
            }

            p {
                margin: 0;
                font-size: 16px;
                font-weight: 500;
            }
        }
    }

    .stats-grid {
        position: relative;

        &.loading {
            opacity: 0.6;
            pointer-events: none;
        }
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

// Responsive
@media (max-width: 768px) {
    .dm-dashboard {
        padding: 15px;

        .dashboard-header {
            h1 {
                font-size: 2em;
            }
        }

        .dashboard-content {
            .stats-grid {
                grid-template-columns: 1fr;
                gap: 15px;
            }

            .executions-section {
                .executions-container {
                    grid-template-columns: 1fr;
                    gap: 20px;

                    .executions-summary {
                        .summary-card {
                            .summary-header {
                                flex-direction: column;
                                gap: 10px;
                                align-items: flex-start;

                                .date-filter-inline {
                                    .el-date-editor {
                                        width: 100% !important;
                                    }
                                }
                            }
                        }
                    }

                    .executions-chart {
                        .chart-header {
                            flex-direction: column;
                            gap: 10px;
                            align-items: flex-start;
                        }

                        .chart-container {
                            .chart-bars {
                                height: 120px;

                                .chart-hour {
                                    .bars-container {
                                        height: 60px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>